import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [37.544475, -77.440014, 53.6],
  [37.544449, -77.439891, 53.6],
  [37.544392, -77.439773, 53.4],
  [37.544328, -77.439677, 53.4],
  [37.544264, -77.439569, 53.4],
  [37.544199, -77.439473, 53.4],
  [37.544138, -77.439371, 53.4],
  [37.544076, -77.439263, 53.4],
  [37.544011, -77.439156, 53.4],
  [37.54395, -77.439049, 53.2],
  [37.543885, -77.438942, 53.2],
  [37.543816, -77.438824, 53.2],
  [37.543743, -77.438706, 53.2],
  [37.543676, -77.438588, 53.2],
  [37.543598, -77.438453, 53.2],
  [37.543526, -77.438325, 53.4],
  [37.543451, -77.438196, 53.4],
  [37.543373, -77.438067, 53.6],
  [37.543293, -77.437938, 53.8],
  [37.543218, -77.43781, 54.2],
  [37.543137, -77.437676, 54.4],
  [37.543062, -77.437541, 54.6],
  [37.542982, -77.437413, 54.8],
  [37.542901, -77.437273, 55],
  [37.542826, -77.43715, 55],
  [37.542748, -77.437021, 54.8],
  [37.542673, -77.436898, 54.8],
  [37.542606, -77.436801, 54.8],
  [37.542555, -77.436715, 54.8],
  [37.542512, -77.436646, 54.8],
  [37.542475, -77.436592, 54.6],
  [37.542434, -77.436533, 54.6],
  [37.542397, -77.436474, 54.6],
  [37.542357, -77.436393, 54.6],
  [37.542314, -77.436329, 54.4],
  [37.542271, -77.436249, 54.4],
  [37.54223, -77.436174, 54.2],
  [37.542196, -77.43612, 54.2],
  [37.542169, -77.436082, 54.2],
  [37.542158, -77.436066, 54.2],
  [37.542153, -77.436061, 54.2],
  [37.542145, -77.436045, 54.2],
  [37.542139, -77.436039, 54.2],
  [37.542126, -77.436023, 54.2],
  [37.542123, -77.436013, 54.2],
  [37.542115, -77.436007, 54.2],
  [37.542115, -77.436007, 54.2],
  [37.542099, -77.435986, 54],
  [37.542078, -77.435943, 54],
  [37.542053, -77.4359, 54],
  [37.542024, -77.435846, 54],
  [37.541992, -77.435793, 53.8],
  [37.541962, -77.435734, 53.8],
  [37.541925, -77.435669, 53.8],
  [37.541887, -77.4356, 53.8],
  [37.541844, -77.435535, 53.6],
  [37.541799, -77.435455, 53.6],
  [37.541753, -77.43539, 53.4],
  [37.541702, -77.435305, 53.4],
  [37.541654, -77.435229, 53.2],
  [37.5416, -77.435144, 53.2],
  [37.541552, -77.435063, 53],
  [37.541498, -77.434967, 53],
  [37.541445, -77.434875, 52.8],
  [37.541386, -77.434784, 52.8],
  [37.541329, -77.434693, 52.6],
  [37.541276, -77.434602, 52.6],
  [37.541219, -77.434505, 52.4],
  [37.54116, -77.434403, 52.2],
  [37.541104, -77.434307, 52.2],
  [37.541042, -77.434205, 52],
  [37.540983, -77.434108, 52],
  [37.540922, -77.434006, 52],
  [37.540857, -77.43391, 51.8],
  [37.54079, -77.433802, 51.6],
];

export default stream;
